import React from 'react';
import {
  ResponsiveContainer,
  RadarChart,
  Radar,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Tooltip,
} from 'recharts';
import RadarTooltip from './RadarTooltip';
import AiConfidenceMeter from './AIConfidenceMeter';
import '../styles/ClaimResult.css';

export default function AiSummaryPanel({ radarData, counts }) {
  // Ensure data is properly formatted - normalize if needed
  const normalizedData = radarData.map(item => ({
    ...item,
    A: Number(item.A), // Ensure A is a number
    fullMark: Number(item.fullMark || 100) // Ensure fullMark is a number
  }));

  return (
    <section className="analysis-row-panel">
      <div className="radar-box aligned-box">
        <h2>🧠 AI Analysis Radar</h2>
        <p className="ai-analysis-sub">
          Score on each Area A.I. used to analyse and can come up with the Verdict. Full score is 100, meaning the evidence is most supportive to the claim
        </p>
        <ResponsiveContainer width="100%" height={400}>
          <RadarChart
            cx="50%"
            cy="50%"
            outerRadius="77%"
            data={normalizedData}
          >
            <PolarGrid gridType="circle" />
            <PolarAngleAxis
              dataKey="subject"
              tick={({ payload, x, y, textAnchor, index }) => {
                const words = payload.value.split(' ');
                const midpoint = Math.ceil(words.length / 2);
                const lines = words.length > 1
                  ? [words.slice(0, midpoint).join(' '), words.slice(midpoint).join(' ')]
                  : [payload.value];

                // Calculate the angle properly
                const angle = (360 / normalizedData.length) * index;
                let baseDy = -10; // default

                // Adjust vertical position based on angle
                if (angle > 260 || angle < 100) {
                  baseDy = -14;
                }

                return (
                  <text
                    x={x}
                    y={y + baseDy}
                    textAnchor={textAnchor}
                    fontSize={13}
                    fill="#1f2f36"
                    fontWeight={600}
                  >
                    {lines.map((line, i) => (
                      <tspan x={x} dy={i === 0 ? 0 : 16} key={i}>
                        {line}
                      </tspan>
                    ))}
                  </text>
                );
              }}
            />

            {/* Set explicit domain to ensure proper scaling */}
            <PolarRadiusAxis angle={30} domain={[0, 100]} tick={{ fill: '#666', fontSize: 12 }} />
            
            {/* Background shape (reference) */}
            <Radar
              name="Reference"
              dataKey="fullMark"
              stroke="#cce5cc"
              fill="rgba(204, 229, 204, 0.4)"
              isAnimationActive={false}
            />
            
            {/* Actual data shape */}
            <Radar
              name="AI Confidence"
              dataKey="A"
              stroke="#2e7d32"
              fill="rgba(46, 125, 50, 0.6)"
              fillOpacity={0.6}
              animationDuration={500}
              dot={{ stroke: '#2e7d32', strokeWidth: 2, fill: 'white', r: 3 }}
            />
            
            <Tooltip content={<RadarTooltip />} />
          </RadarChart>
        </ResponsiveContainer>
      </div>

      <div className="ai-meter-box-wrap aligned-box">
        <h2>📊 AI Confidence Overview</h2>
        <p className="ai-analysis-sub">
          Summary of verdict distribution across all analyzed speeches and votes.
        </p>
        <AiConfidenceMeter counts={counts} />
      </div>
    </section>
  );
}